import { Query, QueryHandler, RootContextBase } from '@skylab-shared/core';
import { CompanyParametersQuery } from '../../company/queries/company-parameters.query-base';
import { VatRateForSaleQuery } from './vat-rate-for-sale.query-base';
import { VatRateItem } from './vat-rate-item';


export class VatRateForSaleBaseQuery extends Query<VatRateItem[]> { }

export class VatRateForSaleBaseQueryHandlerBase implements QueryHandler<VatRateForSaleBaseQuery, VatRateItem[]> {
    public constructor(
        private readonly rootContext: RootContextBase
    ) { }

    public async handleAsync(_: VatRateForSaleBaseQuery): Promise<VatRateItem[]> {
        const { systemCountryId } = await this.rootContext.preload(CompanyParametersQuery);
        const vatRates = await this.rootContext.preload(VatRateForSaleQuery);
        return vatRates.filter(elem => elem.countryId === systemCountryId);
    }
}
